<template>
  <div v-on="$listeners">
    [x] Tonen nadat begintijd is verlopen

    <div>
      <label><input name="type" type="radio" v-model="data.type" :value="'date'"> Datum</label>
      <label><input name="type" type="radio" v-model="data.type" :value="'count'"> Teller</label>
      <label><input name="type" type="radio" v-model="data.type" :value="'total'"> Totalen</label>

      <base-input v-model="data.format">Format</base-input>
    </div>

    <br />

    <div v-if="data.type === 'date'">

      <label><input type="radio" v-model="data.setting" value="both" /> Begin en eind</label>
      <label><input type="radio" v-model="data.setting" value="start" /> Begin</label>
      <label><input type="radio" v-model="data.setting" value="end" /> Eind</label>

    </div>


    <div v-if="data.type === 'count'">
      <label v-for="countType in countTypes" :key="countType.type"><input name="count" type="radio" v-model="data.count" :value="countType.type">
        {{ countType.label }}</label>
    </div>
  </div>
</template>

<script>
export default {
  name: "SettingsDaycounter",
  props: {
    data: {
      required: true
    }
  },
  data() {
    return {
      countTypes: [
        {type: 'years', label: 'Jaar'},
        {type: 'months', label: 'Maand'},
        {type: 'weeks', label: 'Week'},
        {type: 'days', label: 'Dag'},
        {type: 'hours', label: 'Uur'},
        {type: 'minutes', label: 'Minuut'},
        {type: 'seconds', label: 'Seconde'},
      ]
    }
  }
}
</script>

<style scoped lang="scss">
label {
  @apply block;
}
</style>